import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const useEmailAddressContactUs = () => {
  const navigate = useNavigate();

  const [showModal, setShowModal] = useState(false);
  const [state, setState] = useState({
    phoneNumber: "",
    phoneNumberStatus: "normal",
    phoneNumberErrorMessage: "",
    category: "",
    categoryStatus: "normal",
    categoryErrorMessage: "",
    description: "",
    descriptionStatus: "normal",
    descriptionErrorMessage: "",
  });

  const handleForms = (field) => (e) => {
    if (field === "category") {
      setState({
        ...state,
        [field]: e,
      });

      return;
    }

    setState({
      ...state,
      [field]: e.target.value,
    });
  };

  const handleSubmit = () => {
    if (
      !state.phoneNumber ||
      state.phoneNumber.length < 10 ||
      state.phoneNumber.length > 13
    ) {
      setState({
        ...state,
        phoneNumberStatus: "error",
        phoneNumberErrorMessage: "Mobile number must consist of 10-13 digit",
      });

      return;
    }

    if (!state.category) {
      setState({
        ...state,
        categoryStatus: "error",
        categoryErrorMessage: "This field is required",
        phoneNumberStatus: "normal",
        phoneNumberErrorMessage: "",
      });

      return;
    }

    if (!state.description) {
      setState({
        ...state,
        descriptionStatus: "error",
        descriptionErrorMessage: "This field is required",
        categoryStatus: "normal",
        categoryErrorMessage: "",
      });

      return;
    }

    setState({
      ...state,
      descriptionStatus: "normal",
      descriptionErrorMessage: "",
    });

    setShowModal(true);
  };

  const handleBackToSignIn = () => {
    navigate("/login/email-address");
  };

  return {
    showModal,
    state,
    handleForms,
    handleSubmit,
    handleBackToSignIn,
  };
};
